import { defineMessages } from "react-intl";

export default {
  short: defineMessages({
    hour: {
      id: "timeUnits.hour.short",
      defaultMessage: "h",
    },
    day: {
      id: "timeUnits.day.short",
      defaultMessage: "d",
    },
    week: {
      id: "timeUnits.week.short",
      defaultMessage: "w",
    },
    month: {
      id: "timeUnits.month.short",
      defaultMessage: "m",
    },
    quarter: {
      id: "timeUnits.quarter.short",
      defaultMessage: "q",
    },
    year: {
      id: "timeUnits.year.short",
      defaultMessage: "y",
    },
  }),
  long: defineMessages({
    hour: {
      id: "timeUnits.hour.long",
      defaultMessage: "hour",
    },
    day: {
      id: "timeUnits.day.long",
      defaultMessage: "day",
    },
    week: {
      id: "timeUnits.week.long",
      defaultMessage: "week",
    },
    month: {
      id: "timeUnits.month.long",
      defaultMessage: "month",
    },
    quarter: {
      id: "timeUnits.quarter.long",
      defaultMessage: "quarter",
    },
    year: {
      id: "timeUnits.year.long",
      defaultMessage: "year",
    },
  }),
};
